import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { TOption } from "@/types/common";
import { FILE_INCORRECT } from "@/features/company/constants/excel";
import { PARTNER_CONTACT_METHOD_LABELS, PARTNER_ITEM_NAME_LABELS } from "@/features/partner/constants/import";
import {
  PARTNER_CONTACT_METHOD_COLUMN,
  PARTNER_EXCEL_COLUMN_WIDTHS,
  PARTNER_EXCEL_HEADERS,
  PARTNER_NATIONALITY_COLUMN,
} from "@/features/partner/constants/excel-columns";

const headers = PARTNER_EXCEL_HEADERS;

const COLUMN_WIDTHS = PARTNER_EXCEL_COLUMN_WIDTHS;

const SAMPLE_ROW = [
  "P-0001",
  "いろはな人材サービス",
  `${PARTNER_ITEM_NAME_LABELS[0]}、${PARTNER_ITEM_NAME_LABELS[1]}`,
  "ベトナム",
  "",
  "",
  "ハノイ市カウザイ区",
  "担当",
  "メール",
  "090-1234-5678",
  "email@irohana.com",
  "LINE: irohana",
  "2025年4月1日締結",
  "毎月末締め翌月末払い",
  "来月担当者が変更になる",
];

export const downloadPartnerSample = async (nationalityOptions: TOption[], contactMethodOptions: TOption[] = []) => {
  const nationalityLabels = nationalityOptions.filter((option) => !option.hidden).map((option) => String(option.label));
  const contactMethodLabels = contactMethodOptions.length
    ? contactMethodOptions.map((option) => String(option.label))
    : [...PARTNER_CONTACT_METHOD_LABELS];
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("パートナー情報");
  const nationalitySheet = workbook.addWorksheet("Nationality");
  const itemNameSheet = workbook.addWorksheet("ItemName");
  const contactMethodSheet = workbook.addWorksheet("ContactMethod");

  nationalityLabels.forEach((label, idx) => {
    nationalitySheet.getCell("A" + (idx + 1)).value = label;
  });
  nationalitySheet.state = "veryHidden";

  PARTNER_ITEM_NAME_LABELS.forEach((label, idx) => {
    itemNameSheet.getCell("A" + (idx + 1)).value = label;
  });
  itemNameSheet.state = "veryHidden";

  contactMethodLabels.forEach((label, idx) => {
    contactMethodSheet.getCell("A" + (idx + 1)).value = label;
  });
  contactMethodSheet.state = "veryHidden";

  const headerRow = sheet.addRow(headers);
  sheet.addRow(SAMPLE_ROW);

  headerRow.eachCell((cell, colNumber) => {
    cell.font = { bold: true, size: 16, color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "4472C4" },
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    sheet.getColumn(colNumber).width = COLUMN_WIDTHS[colNumber - 1] ?? 15;
  });

  const totalRows = 100;
  const nationalityCount = nationalityLabels.length;

  for (let i = 2; i <= totalRows + 1; i++) {
    if (nationalityCount) {
      sheet.getCell(`${PARTNER_NATIONALITY_COLUMN}${i}`).dataValidation = {
        type: "list",
        formulae: [`=Nationality!$A$1:$A$${nationalityCount}`],
        showInputMessage: true,
      };
    }

    sheet.getCell(`${PARTNER_CONTACT_METHOD_COLUMN}${i}`).dataValidation = {
      type: "list",
      formulae: [`=ContactMethod!$A$1:$A$${contactMethodLabels.length}`],
      showInputMessage: true,
    };
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/octet-stream" });
  saveAs(blob, "パートナー情報_サンプル.xlsx");
};

export const validatePartnerFileFormat = (rowHeader: string[]) => {
  const header = rowHeader.filter((h) => h !== "").map((h) => String(h).trim());

  if (header.length !== headers.length) {
    throw new Error(FILE_INCORRECT);
  }

  for (let i = 0; i < headers.length; i++) {
    if (header[i] !== headers[i]) {
      throw new Error(FILE_INCORRECT);
    }
  }

  return true;
};
